/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit EmailAddress/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function EmailAddress({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Email/NewEmail/Content/NewRelation/Add/Content/Email/Fields/EmailAddress",
  isInvalid,
  onChange
  
}) {
let newEmailEmailAddressValueData = fromData.useDataValue({ viewPath,
context: 'new_email',
path: 'email.address',
})
let newEmailEmailAddressIsValidData = fromData.useDataIsValid({ viewPath,
context: 'new_email',
path: 'email.address',
validate: fromValidate.email,
required: true,
})
let newEmailEmailAddressChangeData = fromData.useDataChange({ viewPath,
context: 'new_email',
path: 'email.address',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="new_email.email.address"
 validate="/Data/validate.js email"
 invalid={!newEmailEmailAddressIsValidData}
 required={true}
 value={newEmailEmailAddressValueData}
 onChange={newEmailEmailAddressChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Email"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 type="text"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}